import CustomerPortalApi from '../api/CustomerPortal';
import * as ActionTypes from './ActionTypes';
export function getCustomerPortalSettings() {
  return dispatch => {
    dispatch({
      type: ActionTypes.FETCH_CUSTOMER_PORTAL_SETTINGS_PENDING
    });
    return CustomerPortalApi.get().then(payload => dispatch({
      type: ActionTypes.FETCH_CUSTOMER_PORTAL_SETTINGS_SUCCESS,
      payload
    }), error => {
      dispatch({
        type: ActionTypes.FETCH_CUSTOMER_PORTAL_SETTINGS_ERROR,
        error
      });
    });
  };
}